var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L7 7",
    stroke: "#DC0202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1L1 7",
    stroke: "#DC0202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.3489be21b38ac26569fe75c7fd8a8718.svg";
export { ForwardRef as ReactComponent };